// Discreet "bip" using WebAudio - no external asset needed
let _ctx = null;
const tone = (freq, start, dur, vol = 0.2) => {
  const osc = _ctx.createOscillator();
  const g = _ctx.createGain();
  osc.type = "triangle";
  osc.frequency.setValueAtTime(freq, start);
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(vol, start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(g).connect(_ctx.destination);
  osc.start(start);
  osc.stop(start + dur + 0.02);
};
// Stronger 3-tone chime for transfers / unattended contacts
export function playAlert() {
  if (typeof window === "undefined") return;
  if (localStorage.getItem("cz_sound") === "0") return;
  try {
    _ctx = _ctx || new (window.AudioContext || window.webkitAudioContext)();
    const now = _ctx.currentTime;
    [660, 880, 1175].forEach((f, i) => tone(f, now + i * 0.16, 0.22, 0.25));
  } catch (_) {}
}
export function playBip() {
  if (typeof window === "undefined") return;
  if (localStorage.getItem("cz_sound") === "0") return;
  try {
    _ctx = _ctx || new (window.AudioContext || window.webkitAudioContext)();
    const now = _ctx.currentTime;
    const osc = _ctx.createOscillator();
    const g = _ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.exponentialRampToValueAtTime(1320, now + 0.08);
    g.gain.setValueAtTime(0.0001, now);
    g.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
    osc.connect(g).connect(_ctx.destination);
    osc.start(now);
    osc.stop(now + 0.25);
  } catch (_) {}
}
